import { render, staticRenderFns } from "./ArtXlsList.vue?vue&type=template&id=44bfa612&scoped=true&"
import script from "./ArtXlsList.vue?vue&type=script&lang=js&"
export * from "./ArtXlsList.vue?vue&type=script&lang=js&"
import style0 from "./ArtXlsList.vue?vue&type=style&index=0&id=44bfa612&scoped=true&lang=scss&"
import style1 from "./ArtXlsList.vue?vue&type=style&index=1&id=44bfa612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bfa612",
  null
  
)

export default component.exports